import { CUSTOM_SCHEME_PREFIX } from '../services/api-constants';

const isCustomScheme = (url: string) => Object.values(CUSTOM_SCHEME_PREFIX).some((scheme) => url?.startsWith(scheme));

export default isCustomScheme;
